const referralRejectionReason = Object.freeze({
  RecibeServiciosRP: 25,
  RechazoServiciosPartePadreMadreEncargado: 42,
  ReferidoVinculadoLugarServicioIncorrecto: 43,
  EspecialistaNoTieneEspacioDisponible: 44,
  NoSeLogroContactarEncargados: 48,
  LosEncargadosRechazaronOfrecimientoServicioTerapeutico: 49,
});

export default referralRejectionReason;
